<rfx-grid-action-bar-control
    matTooltip="Add Tags"
    [matTooltipShowDelay]="500"
    [matTooltipHideDelay]="500"
>
    <fa-icon [icon]="icon"></fa-icon>
</rfx-grid-action-bar-control>
